var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { deletionTable } from '../../../registry/migration_table';
import { flatten } from '../../../utils/helper/lodash_replacements';
export class ConsistencerAdmin {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get consistencyDirector() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    get isAdminConsistencyEnabled() {
        return !!this.app.user && this.app.user.userPermissions.hasAdminPermissionsForCurrentLocation;
    }
    get obsoleteTraitsToDelete() {
        if (!this.isAdminConsistencyEnabled)
            return [];
        return flatten(deletionTable.traitRegistry.map(key => this.app.importingTree.importingSearch.allTraitsOfKey(key)));
    }
}
__decorate([
    computed
], ConsistencerAdmin.prototype, "isAdminConsistencyEnabled", null);
__decorate([
    computed
], ConsistencerAdmin.prototype, "obsoleteTraitsToDelete", null);
